export default __webpack_public_path__ + "fa4f82dd6306550717a697f805bd9e45.svg";